<div class="w-full">
	<!-- COUNTRIES -->
	<div
		class="max-w-[431px] flex justify-evenly items-center py-[8px] max-mobile:p-0 px-[10px] bg-off-white rounded-[50px] text-dark-grey mb-[55px] text-font-16 cursor-pointer border-secondry-color-Gray border-[1px]"
	>
		<a
			class="text-center w-[55%] max-mobile:m-[3px] flex gap-2 justify-center items-center {{
				branches ? 'fill-[#7e2eb3]' : 'fill-[#6E7191]'
			}}"
			[ngClass]="{ activeClass: branches }"
			(click)="branches = true; stores = false"
		>
			<!-- prettier-ignore -->
			<svg width="26" height="26" viewBox="0 0 26 26" class="group:fill-dark-grey" xmlns="http://www.w3.org/2000/svg">
				<path d="M5.95964 11.6458C3.42464 11.6458 1.35547 9.57667 1.35547 7.04167C1.35547 4.50667 3.42464 2.4375 5.95964 2.4375C8.49463 2.4375 10.5638 4.50667 10.5638 7.04167C10.5638 9.57667 8.49463 11.6458 5.95964 11.6458ZM5.95964 4.0625C4.31297 4.0625 2.98047 5.395 2.98047 7.04167C2.98047 8.68833 4.31297 10.0208 5.95964 10.0208C7.6063 10.0208 8.9388 8.68833 8.9388 7.04167C8.9388 5.395 7.6063 4.0625 5.95964 4.0625Z" />
				<path d="M5.95964 23.5638C3.42464 23.5638 1.35547 21.4946 1.35547 18.9596C1.35547 16.4246 3.42464 14.3555 5.95964 14.3555C8.49463 14.3555 10.5638 16.4246 10.5638 18.9596C10.5638 21.4946 8.49463 23.5638 5.95964 23.5638ZM5.95964 15.9805C4.31297 15.9805 2.98047 17.313 2.98047 18.9596C2.98047 20.6063 4.31297 21.9388 5.95964 21.9388C7.6063 21.9388 8.9388 20.6063 8.9388 18.9596C8.9388 17.313 7.6063 15.9805 5.95964 15.9805Z"/>
				<path d="M9.37139 18.1245C9.12222 18.1245 8.88388 18.0161 8.72138 17.7995C8.45055 17.442 8.52641 16.9328 8.88391 16.662L23.3464 5.8503C23.7039 5.57946 24.2131 5.6553 24.4839 6.0128C24.7547 6.3703 24.6789 6.87946 24.3214 7.15029L9.8589 17.962C9.71807 18.0703 9.54472 18.1245 9.37139 18.1245Z" />
				<path d="M23.8339 20.2807C23.6606 20.2807 23.498 20.2265 23.3464 20.1182L8.88391 9.30654C8.52641 9.03571 8.45055 8.52655 8.72138 8.16905C8.99221 7.81155 9.5014 7.73571 9.8589 8.00655L24.3214 18.8182C24.6789 19.089 24.7547 19.5982 24.4839 19.9557C24.3214 20.1615 24.0831 20.2807 23.8339 20.2807Z" />
				<defs>
				<linearGradient id="paint0_linear_58179_101699" x1="1.35547" y1="7.04167" x2="10.5638" y2="7.04167" gradientUnits="userSpaceOnUse">
				</linearGradient>
				<linearGradient id="paint1_linear_58179_101699" x1="1.35547" y1="18.9596" x2="10.5638" y2="18.9596" gradientUnits="userSpaceOnUse">

				</linearGradient>
				<linearGradient id="paint2_linear_58179_101699" x1="8.55859" y1="11.906" x2="24.6467" y2="11.906" gradientUnits="userSpaceOnUse">
	
				</linearGradient>
				<linearGradient id="paint3_linear_58179_101699" x1="8.55859" y1="14.0622" x2="24.6467" y2="14.0622" gradientUnits="userSpaceOnUse">
	
				</linearGradient>
				</defs>
				</svg>

			<p class="mt-3">
				{{ 'ORGANIZATION.SP_PROFILE.BEAUTY_SALONS' | translate }}
			</p>
		</a>

		<a
			class="text-center w-[55%] max-mobile:m-[3px] flex gap-2 justify-center items-center {{
				stores ? 'fill-[#7e2eb3]' : 'fill-[#6E7191]'
			}} "
			[ngClass]="{ activeClass: stores }"
			(click)="branches = false; stores = true"
		>
			<!-- prettier-ignore -->
			<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" >
			<path d="M15.9259 24.6471H10.0759C4.72422 24.6471 2.44922 22.3612 2.44922 17.0204V12.1562C2.44922 11.7121 2.81755 11.3438 3.26172 11.3438C3.70589 11.3438 4.07422 11.7121 4.07422 12.1562V17.0204C4.07422 21.4513 5.64505 23.0221 10.0759 23.0221H15.9151C20.3459 23.0221 21.9167 21.4513 21.9167 17.0204V12.1562C21.9167 11.7121 22.2851 11.3438 22.7292 11.3438C23.1734 11.3438 23.5417 11.7121 23.5417 12.1562V17.0204C23.5526 22.3612 21.2667 24.6471 15.9259 24.6471Z" />
			<path d="M12.9999 13.8138C11.8083 13.8138 10.7249 13.348 9.95575 12.4921C9.18659 11.6363 8.82909 10.5205 8.94825 9.3288L9.67409 2.09214C9.71742 1.68047 10.0641 1.35547 10.4866 1.35547H15.5458C15.9683 1.35547 16.3149 1.66964 16.3583 2.09214L17.0841 9.3288C17.2033 10.5205 16.8458 11.6363 16.0766 12.4921C15.2749 13.348 14.1916 13.8138 12.9999 13.8138ZM11.2124 2.98047L10.5624 9.4913C10.4866 10.2171 10.7033 10.8996 11.1583 11.398C12.0791 12.4163 13.9208 12.4163 14.8416 11.398C15.2966 10.8888 15.5133 10.2063 15.4374 9.4913L14.7874 2.98047H11.2124Z" />
			<path d="M19.837 13.8138C17.6378 13.8138 15.677 12.0371 15.4495 9.8488L14.6911 2.25464C14.6695 2.02714 14.7453 1.79964 14.897 1.6263C15.0486 1.45297 15.2653 1.35547 15.5036 1.35547H18.8078C21.9928 1.35547 23.477 2.68797 23.9211 5.95964L24.2245 8.9713C24.3545 10.2496 23.9645 11.463 23.1303 12.3838C22.2961 13.3046 21.1261 13.8138 19.837 13.8138ZM16.4028 2.98047L17.0745 9.6863C17.2153 11.0405 18.472 12.1888 19.837 12.1888C20.6603 12.1888 21.397 11.8746 21.9278 11.3005C22.4478 10.7263 22.6861 9.95714 22.6103 9.1338L22.307 6.15463C21.9711 3.7063 21.1803 2.98047 18.8078 2.98047H16.4028Z"/>
			<path d="M6.11124 13.8138C4.82208 13.8138 3.65208 13.3046 2.81791 12.3838C1.98374 11.463 1.59374 10.2496 1.72374 8.9713L2.01624 5.99214C2.47124 2.68797 3.95541 1.35547 7.14041 1.35547H10.4446C10.6721 1.35547 10.8887 1.45297 11.0512 1.6263C11.2137 1.79964 11.2787 2.02714 11.2571 2.25464L10.4987 9.8488C10.2712 12.0371 8.31041 13.8138 6.11124 13.8138ZM7.14041 2.98047C4.76791 2.98047 3.97708 3.69547 3.63041 6.1763L3.33791 9.1338C3.25124 9.95714 3.50041 10.7263 4.02041 11.3005C4.54041 11.8746 5.27708 12.1888 6.11124 12.1888C7.47624 12.1888 8.74374 11.0405 8.87374 9.6863L9.54541 2.98047H7.14041Z" />
			<path d="M15.7096 24.6471H10.293C9.8488 24.6471 9.48047 24.2788 9.48047 23.8346V21.1263C9.48047 18.8513 10.7263 17.6055 13.0013 17.6055C15.2763 17.6055 16.5221 18.8513 16.5221 21.1263V23.8346C16.5221 24.2788 16.1538 24.6471 15.7096 24.6471ZM11.1055 23.0221H14.8971V21.1263C14.8971 19.7613 14.3663 19.2305 13.0013 19.2305C11.6363 19.2305 11.1055 19.7613 11.1055 21.1263V23.0221Z" />
			</svg>
			<p class="mt-3">
				{{ 'ORGANIZATION.SP_PROFILE.ONLINE_STORS' | translate }}
			</p>
		</a>
	</div>
	<div
		*ngIf="branches"
		class="bg-off-white rounded-12px py-[29px] translate-y-[-29px]"
	>
		<div class="flex flex-wrap p-24px justify-between">
			<h1 class="text-font-18 leading-22px m-0 text-dark-grey">
				{{ 'ORGANIZATION.SP_PROFILE.BRANCHES' | translate }}
				<span
					dir="ltr"
					class="block text-font-12 text-[#6E7191] text"
					*ngIf="organization?.branches?.length > 1"
				>
					{{ organization?.branches?.length }}
					{{ 'ORGANIZATION.SP_PROFILE.BRANCHES' | translate }}</span
				>
				<span
					dir="ltr"
					class="block text-font-12 text-[#6E7191] ltr"
					*ngIf="organization?.branches?.length == 1"
				>
					{{ organization?.branches?.length }}
					{{ 'ORGANIZATION.SP_PROFILE.BRANCH' | translate }}</span
				>
			</h1>

			<!-- UNCOMMENT WHEN NEEDED -->
			<!-- <a class="text-link text-font-14" href="#">{{
				'ORGANIZATION.SP_PROFILE.VIEW_REPORT' | translate
			}}</a> -->
			<!-- UNCOMMENT WHEN NEEDED -->
		</div>
		<div class="w-[96%] h-[1px] bg-secondry-color-Gray m-auto mb-24px"></div>
		<!-- ----------SECTION ONE--------- -->
		<div
			class="px-24px border-secondry-color-Gray border-[1px] rounded-6px mx-24px"
		>
			<div class="rounded-[6px] flex py-24px justify-start overflow-x-auto">
				<div
					class="border-[1px] rounded-12px mr-12px min-w-[350px] max-mobile:w-full md:max-lg:w-1/3 mb-12px relative"
					(click)="selectedBranch = branch; changeTitle()"
					[ngClass]="
						selectedBranch?.id == branch?.id
							? 'bg-[#222433] text-off-white'
							: 'border-[1px]'
					"
					*ngFor="let branch of organization?.branches; let indx = index"
				>
					<div
						class="flex px-[20px] py-[21px] max-mobile:pl-8px max-mobile:pr-12px md:max-lg:pl-8px md:max-lg:pr-12px"
					>
						<div>
							<img
								class="self-start rtl:ml-12px ltr:mr-12px"
								[src]="
									branch?.targetAudience.includes(0) &&
									branch?.targetAudience.includes(1)
										? './assets/images/male-female-sign.svg'
										: branch?.targetAudience.includes(0)
										? './assets/images/female-sign.svg'
										: branch?.targetAudience.includes(1)
										? './assets/images/male-sign.svg'
										: ''
								"
								alt=""
								[ngClass]="
									selectedBranch?.id == branch?.id ? 'gradient-border' : ''
								"
							/>
							<!-- branch?.targetAudience?.includes(0) -->
						</div>
						<div class="w-[90%]">
							<div
								class="flex justify-between mb-[6px]"
								[ngClass]="
									selectedBranch?.id == branch?.id
										? ' text-off-white'
										: 'text-dark-grey'
								"
							>
								<h1
									class="ltr:font-DIN-Bold font-bold rtl:font-medium text-font-16 leading-[20px] m-0 max-mobile:text-font-mobile-small"
								>
									<img
										(mouseover)="
											inCompleteDataHover = true; hoverId = branch?.id
										"
										(mouseout)="inCompleteDataHover = false; hoverId = null"
										*ngIf="!branch.isInformationCompleted"
										class="inline-block"
										src="assets/images/new-danger.svg"
										alt=""
									/>
									<div
										*ngIf="inCompleteDataHover && hoverId == branch?.id"
										class="absolute bg-main-color-black px-[16px] py-12px text-off-white text-font-14 rounded-[4px] max-w-[344px] top-[45px] right-[-15px] z-10"
									>
										{{ 'ORGANIZATION.SP_PROFILE.INFO_MISSING' | translate }}
									</div>
									{{ branch?.name | slice : 0 : 15 }}
									{{
										branch?.name?.length && branch.name.length > 15 ? '...' : ''
									}}

									<img
										*ngIf="branch?.isMain"
										class="inline-block"
										[src]="
											selectedBranch?.id == branch?.id
												? './assets/images/home-white.svg'
												: './assets/images/white.svg'
										"
										alt=""
									/>
								</h1>
								<mat-slide-toggle
									[disabled]="
										organization.status == 4 || !branch.isInformationCompleted
									"
									(change)="
										updateStatus(branch?.id, indx, $event, branch?.isActive)
									"
									[checked]="branch.isActive"
									hideIcon
								></mat-slide-toggle>
							</div>
							<div
								class="inline-block py-[2px] px-[6px] rounded-[50px] mb-[6px]"
								[ngClass]="branch?.isActive ? 'bg-[#E2F5EE]' : 'bg-[#F2B8B5]'"
							>
								<div
									class="rounded-full w-[5px] h-[5px] inline-block m-[2px]"
									[ngClass]="branch?.isActive ? 'bg-[#00BA88]' : 'bg-[#B3261E]'"
								></div>
								<p
									class="inline-block m-0 max-mobile:text-font-mobile-small"
									[ngClass]="
										branch?.isActive ? 'text-[#00BA88]' : 'text-[#B3261E]'
									"
								>
									{{
										branch?.isActive
											? ('ACTIONS.ACTIVE' | translate)
											: ('ACTIONS.INACTIVE' | translate)
									}}
								</p>
							</div>
							<div class="flex mb-[6px]">
								<svg width="17" height="18" viewBox="0 0 17 18" fill="">
									<path
										d="M16.875 7.0875H10.4344L8.4375 0.84375L6.44062 7.0875H0L5.20312 10.9406L3.23438 17.1562L8.4375 13.3031L13.6406 17.1562L11.6438 10.9125L16.875 7.0875Z"
										fill="#FFCE31"
									/>
								</svg>
								<span class="text-font-medium text-[14px]">{{
									branch?.overAllRate
								}}</span
								><span class="text-[12px]"
									>({{ branch?.rateCount }}
									{{ 'ORGANIZATION.SP_PROFILE.RATINGS' | translate }})</span
								>
							</div>
							<p *ngIf="branch.address" class="text-font-14 leading-[22px] m-0">
								{{ branch?.address | slice : 0 : 40 }}
								{{
									branch?.address?.length && branch.address.length > 40
										? '...'
										: ''
								}}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="w-[98%] h-[1px] bg-secondry-color-Gray m-auto my-24px"></div>
			<!-- ----------SECTION TWO--------- -->
			<section>
				<p
					class="text-font-16 text-main-color-black ltr:font-DIN-Bold font-bold rtl:font-medium leading[20px] mb-12px"
				>
					{{ 'ORGANIZATION.SP_PROFILE.CHOOSE_CONTENT' | translate }}
				</p>
				<div
					class="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 gap-3 mb-24px"
				>
					<div
						[routerLink]="'../branch-information/' + selectedBranch?.id + '/1'"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] max-mobile:p-padding-mobile-14 max-mobile:m-0 max-mobile:w-full hover:bg-gradient hover:cursor-pointer group"
					>
						<div class="mb-12px flex justify-between">
							<svg
								viewBox="0 0 21.5 21.48"
								class="group-hover:fill-off-white fill-[#4E4B66] w-6"
							>
								<path
									d="M10.76,21.48A2.66,2.66,0,0,1,9,20.85L7.44,19.5a1.5,1.5,0,0,0-.77-.28H4.92a2.69,2.69,0,0,1-2.68-2.68V14.83A1.45,1.45,0,0,0,2,14.07L.62,12.47A2.73,2.73,0,0,1,.62,9L2,7.4a1.45,1.45,0,0,0,.27-.76V4.94A2.69,2.69,0,0,1,4.92,2.26H6.65A1.62,1.62,0,0,0,7.43,2L9,.62a2.76,2.76,0,0,1,3.49,0L14.07,2a1.57,1.57,0,0,0,.78.28h1.7a2.68,2.68,0,0,1,2.68,2.68v1.7a1.58,1.58,0,0,0,.29.77L20.87,9a2.74,2.74,0,0,1,0,3.49l-1.35,1.58a1.57,1.57,0,0,0-.28.77v1.7a2.68,2.68,0,0,1-2.68,2.68h-1.7a1.66,1.66,0,0,0-.78.29L12.5,20.84A2.64,2.64,0,0,1,10.76,21.48ZM4.92,3.76A1.19,1.19,0,0,0,3.74,4.94v1.7a2.89,2.89,0,0,1-.63,1.73L1.75,10a1.27,1.27,0,0,0,0,1.53l1.36,1.59a3,3,0,0,1,.63,1.73v1.71a1.17,1.17,0,0,0,1.17,1.18H6.65a3,3,0,0,1,1.74.64L10,19.71a1.26,1.26,0,0,0,1.54,0l1.58-1.35a3,3,0,0,1,1.74-.64h1.7a1.18,1.18,0,0,0,1.18-1.18v-1.7a3,3,0,0,1,.64-1.74l1.36-1.59a1.26,1.26,0,0,0,0-1.54L18.37,8.39a3,3,0,0,1-.64-1.74V4.94a1.18,1.18,0,0,0-1.18-1.18h-1.7a3,3,0,0,1-1.75-.64L11.51,1.76a1.26,1.26,0,0,0-1.54,0L8.4,3.12a3,3,0,0,1-1.75.64Zm5.83,11.85a1,1,0,1,1,1-1A1,1,0,0,1,10.75,15.61Zm0-3.15a.76.76,0,0,1-.75-.75V6.87a.75.75,0,0,1,1.5,0V11.7A.75.75,0,0,1,10.75,12.46Z"
								/>
							</svg>
							<div>
								<img
									*ngIf="!selectedBranch?.basicInfoComleted"
									class="inline-block w-6"
									src="assets/images/new-danger.svg"
									alt=""
								/>
							</div>
						</div>

						<p
							class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[18px] group-hover:text-off-white text-start whitespace-nowrap"
						>
							{{ 'ORGANIZATION.SP_PROFILE.BASIC_INFO' | translate }}
						</p>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] px-[10px] border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_BRANCH' | translate }}
							</p>
						</button>
					</div>
					<div
						[routerLink]="'../services'"
						[queryParams]="{
							branchId: selectedBranch?.id,
							targetAudiance: selectedBranch?.targetAudience.join(','),
							countryId: organization?.country?.id,
							tenantId: organization?.id
						}"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] max-mobile:p-padding-mobile-14 max-mobile:m-0 max-mobile:w-full hover:bg-gradient hover:cursor-pointer group"
					>
						<div class="mb-12px flex justify-between h-[26px]">
							<svg
								viewBox="0 0 21.5 20.77"
								class="group-hover:fill-off-white fill-[#4E4B66] w-6"
							>
								<path
									d="M4.25,20.77A4.25,4.25,0,1,1,8.5,16.52,4.26,4.26,0,0,1,4.25,20.77Zm0-7A2.75,2.75,0,1,0,7,16.52,2.75,2.75,0,0,0,4.25,13.77Zm3.15,2a.74.74,0,0,1-.6-.3.75.75,0,0,1,.15-1l13.35-10a.75.75,0,0,1,.9,1.2L7.85,15.6A.74.74,0,0,1,7.4,15.75Zm13.35,2a.76.76,0,0,1-.45-.15L7,7.61a.75.75,0,0,1,.9-1.2l13.35,10a.75.75,0,0,1,.15,1.05A.77.77,0,0,1,20.75,17.74ZM4.5,8.5A4.25,4.25,0,1,1,8.75,4.25,4.26,4.26,0,0,1,4.5,8.5Zm0-7A2.75,2.75,0,1,0,7.25,4.25,2.75,2.75,0,0,0,4.5,1.5Z"
								/>
							</svg>
							<div>
								<img
									*ngIf="!selectedBranch?.hasServices"
									class="inline-block w-6"
									src="assets/images/new-danger.svg"
									alt=""
								/>
							</div>
						</div>
						<p
							class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[18px] group-hover:text-off-white text-start"
						>
							{{ 'ORGANIZATION.SP_PROFILE.SERVICES' | translate }}
						</p>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] px-[10px] border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_SERVICES' | translate }}
							</p>
						</button>
					</div>
					<div
						[routerLink]="'../booking/branch-booking'"
						[queryParams]="{
							branchId: selectedBranch?.id,
							tenantId: organization?.id
						}"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] hover:bg-gradient hover:cursor-pointer group max-mobile:w-full"
					>
						<div class="w-5 mb-[12px]">
							<svg
								viewBox="0 0 19.5 21.5"
								class="group-hover:fill-off-white fill-[#4E4B66]"
							>
								<path
									d="M5.75,4.5A.76.76,0,0,1,5,3.75v-3a.75.75,0,0,1,1.5,0v3A.76.76,0,0,1,5.75,4.5Zm8,0A.76.76,0,0,1,13,3.75v-3a.75.75,0,0,1,1.5,0v3A.76.76,0,0,1,13.75,4.5Zm-7.5,8.75a1,1,0,0,1-.38-.08,1,1,0,0,1-.62-.92,1,1,0,0,1,.08-.38,1.15,1.15,0,0,1,.21-.33,1,1,0,0,1,.33-.21A1,1,0,0,1,7,11.54a1.05,1.05,0,0,1,.29.71,1.5,1.5,0,0,1,0,.2.64.64,0,0,1-.06.18.76.76,0,0,1-.09.18A1.58,1.58,0,0,1,7,13,1.05,1.05,0,0,1,6.25,13.25Zm3.5,0a1,1,0,0,1-.38-.08,1,1,0,0,1-.62-.92,1,1,0,0,1,.08-.38A1.15,1.15,0,0,1,9,11.54a1,1,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1.05,1.05,0,0,1,.29.71,1.5,1.5,0,0,1,0,.2.64.64,0,0,1-.06.18.76.76,0,0,1-.09.18,1.58,1.58,0,0,1-.12.15A1.05,1.05,0,0,1,9.75,13.25Zm3.5,0a1,1,0,0,1-.38-.08,1,1,0,0,1-.33-.21l-.12-.15a.76.76,0,0,1-.09-.18.64.64,0,0,1-.06-.18,1.5,1.5,0,0,1,0-.2,1.05,1.05,0,0,1,.29-.71,1,1,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1.05,1.05,0,0,1,.29.71,1.5,1.5,0,0,1,0,.2.64.64,0,0,1-.06.18.76.76,0,0,1-.09.18A1.58,1.58,0,0,1,14,13,1.05,1.05,0,0,1,13.25,13.25Zm-7,3.5a1,1,0,0,1-.38-.08,1.15,1.15,0,0,1-.33-.21,1.05,1.05,0,0,1-.29-.71,1,1,0,0,1,.08-.38A.93.93,0,0,1,5.54,15a1,1,0,1,1,.71,1.71Zm3.5,0a1,1,0,0,1-1-1,1,1,0,0,1,.08-.38A.93.93,0,0,1,9,15a1,1,0,0,1,1.42,0,.93.93,0,0,1,.21.33,1,1,0,0,1,.08.38,1,1,0,0,1-1,1Zm3.5,0a1.05,1.05,0,0,1-.71-.29.93.93,0,0,1-.21-.33.94.94,0,0,1,0-.76.93.93,0,0,1,.21-.33,1,1,0,0,1,.9-.27.6.6,0,0,1,.19.06l.18.09L14,15a1,1,0,0,1-.71,1.71Zm5-8.16h-17a.75.75,0,0,1,0-1.5h17a.75.75,0,0,1,0,1.5ZM13.75,21.5h-8C2.1,21.5,0,19.4,0,15.75V7.25C0,3.6,2.1,1.5,5.75,1.5h8c3.65,0,5.75,2.1,5.75,5.75v8.5C19.5,19.4,17.4,21.5,13.75,21.5ZM5.75,3C2.89,3,1.5,4.39,1.5,7.25v8.5C1.5,18.61,2.89,20,5.75,20h8C16.61,20,18,18.61,18,15.75V7.25C18,4.39,16.61,3,13.75,3Z"
								/>
							</svg>
						</div>
						<p
							class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[20px] group-hover:text-off-white text-start"
						>
							{{ 'ORGANIZATION.SP_PROFILE.BOOKINGS' | translate }}
						</p>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] lg:px-[10px] px-[3px] text-center border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_BOOKINGS' | translate }}
							</p>
						</button>
					</div>
					<div
						[routerLink]="'../organization_gallery/' + selectedBranch?.id"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] hover:bg-gradient hover:cursor-pointer group max-mobile:w-full"
					>
						<div class="w-5 mb-[12px]">
							<svg
								width="25"
								height="24"
								viewBox="0 0 25 24"
								xmlns="http://www.w3.org/2000/svg"
								class="group-hover:fill-off-white fill-[#4E4B66]"
							>
								<g id="gallery">
									<g id="vuesax/outline/gallery">
										<g id="gallery_2">
											<path
												id="Vector"
												d="M15.5 22.7502H9.5C4.07 22.7502 1.75 20.4302 1.75 15.0002V9.00024C1.75 3.57024 4.07 1.25024 9.5 1.25024H15.5C20.93 1.25024 23.25 3.57024 23.25 9.00024V15.0002C23.25 20.4302 20.93 22.7502 15.5 22.7502ZM9.5 2.75024C4.89 2.75024 3.25 4.39024 3.25 9.00024V15.0002C3.25 19.6102 4.89 21.2502 9.5 21.2502H15.5C20.11 21.2502 21.75 19.6102 21.75 15.0002V9.00024C21.75 4.39024 20.11 2.75024 15.5 2.75024H9.5Z"
											/>
											<path
												id="Vector_2"
												d="M9.5 10.7502C7.98 10.7502 6.75 9.52024 6.75 8.00024C6.75 6.48024 7.98 5.25024 9.5 5.25024C11.02 5.25024 12.25 6.48024 12.25 8.00024C12.25 9.52024 11.02 10.7502 9.5 10.7502ZM9.5 6.75024C8.81 6.75024 8.25 7.31024 8.25 8.00024C8.25 8.69024 8.81 9.25024 9.5 9.25024C10.19 9.25024 10.75 8.69024 10.75 8.00024C10.75 7.31024 10.19 6.75024 9.5 6.75024Z"
											/>
											<path
												id="Vector_3"
												d="M3.1688 19.7003C2.9288 19.7003 2.6888 19.5803 2.5488 19.3703C2.3188 19.0303 2.4088 18.5603 2.7588 18.3303L7.6888 15.0203C8.7688 14.2903 10.2588 14.3803 11.2388 15.2103L11.5688 15.5003C12.0688 15.9303 12.9188 15.9303 13.4088 15.5003L17.5688 11.9303C18.6288 11.0203 20.2988 11.0203 21.3688 11.9303L22.9988 13.3303C23.3088 13.6003 23.3488 14.0703 23.0788 14.3903C22.8088 14.7003 22.3388 14.7403 22.0188 14.4703L20.3888 13.0703C19.8888 12.6403 19.0388 12.6403 18.5388 13.0703L14.3788 16.6403C13.3188 17.5503 11.6488 17.5503 10.5788 16.6403L10.2488 16.3503C9.78879 15.9603 9.0288 15.9203 8.5188 16.2703L3.5888 19.5803C3.4588 19.6603 3.3088 19.7003 3.1688 19.7003Z"
											/>
										</g>
									</g>
								</g>
							</svg>
						</div>
						<p
							class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[20px] group-hover:text-off-white text-start"
						>
							{{ 'ORGANIZATION.SP_PROFILE.GALLERY' | translate }}
						</p>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] lg:px-[10px] px-[3px] text-center border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_GALLERY' | translate }}
							</p>
						</button>
					</div>

					<div
						[routerLink]="'../branch-rating/' + selectedBranch?.id"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] max-mobile:p-padding-mobile-14 max-mobile:m-0 max-mobile:w-full hover:bg-gradient hover:cursor-pointer group"
					>
						<div class="w-5 mb-[12px]">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								class="group-hover:fill-off-white fill-[#4E4B66]"
							>
								<path
									d="M17.6601 22.6703C17.1301 22.6703 16.4501 22.5003 15.6001 22.0003L12.6101 20.2303C12.3001 20.0503 11.7001 20.0503 11.4001 20.2303L8.40012 22.0003C6.63012 23.0503 5.59012 22.6303 5.12012 22.2903C4.66012 21.9503 3.94012 21.0803 4.41012 19.0803L5.12012 16.0103C5.20012 15.6903 5.04012 15.1403 4.80012 14.9003L2.32012 12.4203C1.08012 11.1803 1.18012 10.1203 1.35012 9.60031C1.52012 9.08031 2.06012 8.16031 3.78012 7.87031L6.97012 7.34031C7.27012 7.29031 7.70012 6.97031 7.83012 6.70031L9.60012 3.17031C10.4001 1.56031 11.4501 1.32031 12.0001 1.32031C12.5501 1.32031 13.6001 1.56031 14.4001 3.17031L16.1601 6.69031C16.3001 6.96031 16.7301 7.28031 17.0301 7.33031L20.2201 7.86031C21.9501 8.15031 22.4901 9.07031 22.6501 9.59031C22.8101 10.1103 22.9101 11.1703 21.6801 12.4103L19.2001 14.9003C18.9601 15.1403 18.8101 15.6803 18.8801 16.0103L19.5901 19.0803C20.0501 21.0803 19.3401 21.9503 18.8801 22.2903C18.6301 22.4703 18.2301 22.6703 17.6601 22.6703ZM12.0001 18.5903C12.4901 18.5903 12.9801 18.7103 13.3701 18.9403L16.3601 20.7103C17.2301 21.2303 17.7801 21.2303 17.9901 21.0803C18.2001 20.9303 18.3501 20.4003 18.1301 19.4203L17.4201 16.3503C17.2301 15.5203 17.5401 14.4503 18.1401 13.8403L20.6201 11.3603C21.1101 10.8703 21.3301 10.3903 21.2301 10.0603C21.1201 9.73031 20.6601 9.46031 19.9801 9.35031L16.7901 8.82031C16.0201 8.69031 15.1801 8.07031 14.8301 7.37031L13.0701 3.85031C12.7501 3.21031 12.3501 2.83031 12.0001 2.83031C11.6501 2.83031 11.2501 3.21031 10.9401 3.85031L9.17012 7.37031C8.82012 8.07031 7.98012 8.69031 7.21012 8.82031L4.03012 9.35031C3.35012 9.46031 2.89012 9.73031 2.78012 10.0603C2.67012 10.3903 2.90012 10.8803 3.39012 11.3603L5.87012 13.8403C6.47012 14.4403 6.78012 15.5203 6.59012 16.3503L5.88012 19.4203C5.65012 20.4103 5.81012 20.9303 6.02012 21.0803C6.23012 21.2303 6.77012 21.2203 7.65012 20.7103L10.6401 18.9403C11.0201 18.7103 11.5101 18.5903 12.0001 18.5903Z"
								/>
							</svg>
						</div>
						<p
							class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[18px] group-hover:text-off-white text-start"
						>
							{{ 'ORGANIZATION.SP_PROFILE.RATINGS' | translate }}
						</p>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] px-[10px] border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_RATINGS' | translate }}
							</p>
						</button>
					</div>
					<div
						[routerLink]="'../packages/'"
						[queryParams]="{
							branchId: selectedBranch?.id
						}"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] max-mobile:p-padding-mobile-14 max-mobile:m-0 max-mobile:w-full hover:bg-gradient hover:cursor-pointer group"
					>
						<div class="w-5 mb-[12px]">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="25"
								height="24"
								viewBox="0 0 25 24"
								class="group-hover:fill-off-white"
							>
								<path
									d="M12.2884 11.88C11.7484 11.88 11.1984 11.78 10.7684 11.59L4.86844 8.97C3.36844 8.3 3.14844 7.4 3.14844 6.91C3.14844 6.42 3.36844 5.52 4.86844 4.85L10.7684 2.23C11.6384 1.84 12.9484 1.84 13.8184 2.23L19.7284 4.85C21.2184 5.51 21.4484 6.42 21.4484 6.91C21.4484 7.4 21.2284 8.3 19.7284 8.97L13.8184 11.59C13.3784 11.79 12.8384 11.88 12.2884 11.88ZM12.2884 3.44C11.9484 3.44 11.6184 3.49 11.3784 3.6L5.47844 6.22C4.86844 6.5 4.64844 6.78 4.64844 6.91C4.64844 7.04 4.86844 7.33 5.46844 7.6L11.3684 10.22C11.8484 10.43 12.7184 10.43 13.1984 10.22L19.1084 7.6C19.7184 7.33 19.9384 7.04 19.9384 6.91C19.9384 6.78 19.7184 6.49 19.1084 6.22L13.2084 3.6C12.9684 3.5 12.6284 3.44 12.2884 3.44Z"
								/>
								<path
									d="M12.5 17.09C12.12 17.09 11.74 17.01 11.38 16.85L4.59 13.83C3.56 13.38 2.75 12.13 2.75 11C2.75 10.59 3.09 10.25 3.5 10.25C3.91 10.25 4.25 10.59 4.25 11C4.25 11.55 4.7 12.24 5.2 12.47L11.99 15.49C12.31 15.63 12.68 15.63 13.01 15.49L19.8 12.47C20.3 12.25 20.75 11.55 20.75 11C20.75 10.59 21.09 10.25 21.5 10.25C21.91 10.25 22.25 10.59 22.25 11C22.25 12.13 21.44 13.38 20.41 13.84L13.62 16.86C13.26 17.01 12.88 17.09 12.5 17.09Z"
								/>
								<path
									d="M12.5 22.0902C12.12 22.0902 11.74 22.0102 11.38 21.8502L4.59 18.8302C3.47 18.3302 2.75 17.2202 2.75 15.9902C2.75 15.5802 3.09 15.2402 3.5 15.2402C3.91 15.2402 4.25 15.5902 4.25 16.0002C4.25 16.6302 4.62 17.2102 5.2 17.4702L11.99 20.4902C12.31 20.6302 12.68 20.6302 13.01 20.4902L19.8 17.4702C20.38 17.2102 20.75 16.6402 20.75 16.0002C20.75 15.5902 21.09 15.2502 21.5 15.2502C21.91 15.2502 22.25 15.5902 22.25 16.0002C22.25 17.2302 21.53 18.3402 20.41 18.8402L13.62 21.8602C13.26 22.0102 12.88 22.0902 12.5 22.0902Z"
								/>
							</svg>
						</div>
						<p
							class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[18px] group-hover:text-off-white text-start"
						>
							{{ 'ORGANIZATION.SP_PROFILE.PACKAGES' | translate }}
						</p>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] px-[10px] border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_PACKAGES' | translate }}
							</p>
						</button>
					</div>
					<div
						[routerLink]="'../chat/' + selectedBranch?.id"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] max-mobile:p-padding-mobile-14 max-mobile:m-0 max-mobile:w-full hover:bg-gradient hover:cursor-pointer group"
					>
						<div class="w-5 mb-[12px]">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="25"
								viewBox="0 0 24 25"
								class="group-hover:fill-off-white"
							>
								<path
									d="M9.98999 23.53C9.38999 23.53 8.81999 23.23 8.42999 22.7L7.23001 21.1C7.23001 21.11 7.18 21.08 7.16 21.08H6.79001C3.37001 21.08 1.25 20.15 1.25 15.54V11.54C1.25 7.33001 3.82001 6.23001 5.98001 6.04001C6.22001 6.01001 6.50001 6 6.79001 6H13.19C16.81 6 18.73 7.92001 18.73 11.54V15.54C18.73 15.83 18.72 16.11 18.68 16.38C18.5 18.51 17.4 21.08 13.19 21.08H12.79L11.55 22.7C11.16 23.23 10.59 23.53 9.98999 23.53ZM6.79001 7.5C6.56001 7.5 6.34 7.51 6.13 7.53C3.81 7.73 2.75 9.00001 2.75 11.54V15.54C2.75 18.97 3.81001 19.58 6.79001 19.58H7.19C7.64 19.58 8.14999 19.83 8.42999 20.19L9.63 21.8C9.85001 22.1 10.13 22.1 10.35 21.8L11.55 20.2C11.84 19.81 12.3 19.58 12.79 19.58H13.19C15.73 19.58 17 18.51 17.19 16.23C17.22 15.99 17.23 15.77 17.23 15.54V11.54C17.23 8.75001 15.98 7.5 13.19 7.5H6.79001Z"
								/>
								<path
									d="M9.99023 14.9395C9.43023 14.9395 8.99023 14.4895 8.99023 13.9395C8.99023 13.3895 9.44023 12.9395 9.99023 12.9395C10.5402 12.9395 10.9902 13.3895 10.9902 13.9395C10.9902 14.4895 10.5502 14.9395 9.99023 14.9395Z"
								/>
								<path
									d="M13.1899 14.9395C12.6299 14.9395 12.1899 14.4895 12.1899 13.9395C12.1899 13.3895 12.6399 12.9395 13.1899 12.9395C13.7399 12.9395 14.1899 13.3895 14.1899 13.9395C14.1899 14.4895 13.7399 14.9395 13.1899 14.9395Z"
								/>
								<path
									d="M6.7998 14.9395C6.2398 14.9395 5.7998 14.4895 5.7998 13.9395C5.7998 13.3895 6.2498 12.9395 6.7998 12.9395C7.3498 12.9395 7.7998 13.3895 7.7998 13.9395C7.7998 14.4895 7.3498 14.9395 6.7998 14.9395Z"
								/>
								<path
									d="M17.9401 17.04C17.7401 17.04 17.5401 16.96 17.4001 16.81C17.2401 16.65 17.1701 16.42 17.2001 16.2C17.2301 15.99 17.2401 15.77 17.2401 15.54V11.54C17.2401 8.75001 15.9901 7.5 13.2001 7.5H6.80012C6.57012 7.5 6.35015 7.51 6.14015 7.53C5.92015 7.56 5.69013 7.47999 5.53013 7.32999C5.37013 7.16999 5.28012 6.95001 5.30012 6.73001C5.48012 4.57001 6.59012 2 10.8001 2H17.2001C20.8201 2 22.7401 3.92001 22.7401 7.54001V11.54C22.7401 15.75 20.1701 16.85 18.0101 17.04C17.9801 17.04 17.9601 17.04 17.9401 17.04ZM6.92015 6H13.1901C16.8101 6 18.7301 7.92001 18.7301 11.54V15.41C20.4301 14.99 21.2301 13.74 21.2301 11.54V7.54001C21.2301 4.75001 19.9801 3.5 17.1901 3.5H10.7901C8.59014 3.5 7.35015 4.3 6.92015 6Z"
								/>
							</svg>
						</div>
						<p
							class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[18px] group-hover:text-off-white text-start"
						>
							{{ 'ORGANIZATION.SP_PROFILE.CHAT' | translate }}
						</p>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] px-[10px] border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_CHAT' | translate }}
							</p>
						</button>
					</div>
					<div
						[routerLink]="'/layout/wallet/sp-wallet/' + selectedBranch?.id"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] max-mobile:p-padding-mobile-14 max-mobile:m-0 max-mobile:w-full hover:bg-gradient hover:cursor-pointer group"
					>
						<div class="w-5 mb-[12px]">
							<svg
								width="24"
								height="25"
								viewBox="0 0 24 25"
								class="group-hover:fill-off-white"
							>
								<path
									d="M18.24 22.75H6.76C4.27 22.75 2.25 20.73 2.25 18.24V11.51C2.25 9.02001 4.27 7 6.76 7H18.24C20.73 7 22.75 9.02001 22.75 11.51V12.95C22.75 13.36 22.41 13.7 22 13.7H19.98C19.63 13.7 19.31 13.83 19.08 14.07L19.07 14.08C18.79 14.35 18.66 14.72 18.69 15.1C18.75 15.76 19.38 16.29 20.1 16.29H22C22.41 16.29 22.75 16.63 22.75 17.04V18.23C22.75 20.73 20.73 22.75 18.24 22.75ZM6.76 8.5C5.1 8.5 3.75 9.85001 3.75 11.51V18.24C3.75 19.9 5.1 21.25 6.76 21.25H18.24C19.9 21.25 21.25 19.9 21.25 18.24V17.8H20.1C18.59 17.8 17.31 16.68 17.19 15.24C17.11 14.42 17.41 13.61 18.01 13.02C18.53 12.49 19.23 12.2 19.98 12.2H21.25V11.51C21.25 9.85001 19.9 8.5 18.24 8.5H6.76Z"
								/>
								<path
									d="M3 13.16C2.59 13.16 2.25 12.82 2.25 12.41V7.84006C2.25 6.35006 3.19 5.00001 4.58 4.47001L12.52 1.47001C13.34 1.16001 14.25 1.27005 14.96 1.77005C15.68 2.27005 16.1 3.08005 16.1 3.95005V7.75003C16.1 8.16003 15.76 8.50003 15.35 8.50003C14.94 8.50003 14.6 8.16003 14.6 7.75003V3.95005C14.6 3.57005 14.42 3.22003 14.1 3.00003C13.78 2.78003 13.4 2.73003 13.04 2.87003L5.1 5.87003C4.29 6.18003 3.74 6.97006 3.74 7.84006V12.41C3.75 12.83 3.41 13.16 3 13.16Z"
								/>
								<path
									d="M20.0985 17.8002C18.5885 17.8002 17.3085 16.6802 17.1885 15.2402C17.1085 14.4102 17.4085 13.6002 18.0085 13.0102C18.5185 12.4902 19.2185 12.2002 19.9685 12.2002H22.0485C23.0385 12.2302 23.7985 13.0102 23.7985 13.9702V16.0302C23.7985 16.9902 23.0385 17.7702 22.0785 17.8002H20.0985ZM22.0285 13.7002H19.9785C19.6285 13.7002 19.3085 13.8302 19.0785 14.0702C18.7885 14.3502 18.6485 14.7302 18.6885 15.1102C18.7485 15.7702 19.3785 16.3002 20.0985 16.3002H22.0585C22.1885 16.3002 22.3085 16.1802 22.3085 16.0302V13.9702C22.3085 13.8202 22.1885 13.7102 22.0285 13.7002Z"
								/>
								<path
									d="M14.5 12.75H7.5C7.09 12.75 6.75 12.41 6.75 12C6.75 11.59 7.09 11.25 7.5 11.25H14.5C14.91 11.25 15.25 11.59 15.25 12C15.25 12.41 14.91 12.75 14.5 12.75Z"
								/>
							</svg>
						</div>
						<p
							class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[18px] group-hover:text-off-white text-start"
						>
							{{ 'ORGANIZATION.SP_PROFILE.WALLET' | translate }}
						</p>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] px-[10px] border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_WALLET' | translate }}
							</p>
						</button>
					</div>
				</div>
			</section>
		</div>
	</div>

	<div
		*ngIf="stores"
		class="bg-off-white rounded-12px py-[29px] translate-y-[-29px]"
	>
		<div class="flex flex-wrap p-24px justify-between">
			<h1 class="text-font-18 leading-22px m-0 text-dark-grey">
				{{ 'ORGANIZATION.SP_PROFILE.STORES' | translate }}
				<!-- <span
					dir="ltr"
					class="block text-font-12 text-[#6E7191] text"
					*ngIf="organization?.branches?.length > 1"
				>
					{{ organization?.branches?.length }}
					{{ 'ORGANIZATION.SP_PROFILE.BRANCHES' | translate }}</span
				>
				<span
					dir="ltr"
					class="block text-font-12 text-[#6E7191] ltr"
					*ngIf="organization?.branches?.length == 1"
				>
					{{ organization?.branches?.length }}
					{{ 'ORGANIZATION.SP_PROFILE.BRANCH' | translate }}</span
				> -->
			</h1>

			<!-- UNCOMMENT WHEN NEEDED -->
			<!-- <a class="text-link text-font-14" href="#">{{
				'ORGANIZATION.SP_PROFILE.VIEW_REPORT' | translate
			}}</a> -->
			<!-- UNCOMMENT WHEN NEEDED -->
		</div>
		<div class="w-[96%] h-[1px] bg-secondry-color-Gray m-auto mb-24px"></div>
		<!-- ----------SECTION ONE--------- -->
		<div
			class="px-24px border-secondry-color-Gray border-[1px] rounded-6px mx-24px"
		>
			<div class="rounded-[6px] flex py-24px justify-start overflow-x-auto">
				<div
					class="border-[1px] rounded-[6px] mr-12px min-w-[350px] max-mobile:w-full md:max-lg:w-1/3 mb-12px relative"
					(click)="selectedBranch = branch; changeTitle()"
					[ngClass]="
						selectedBranch?.id == branch?.id
							? 'bg-[#222433] text-off-white'
							: 'border-[1px]'
					"
					*ngFor="let branch of organization?.branches; let indx = index"
				>
					<div
						class="flex px-[20px] py-[21px] max-mobile:pl-8px max-mobile:pr-12px md:max-lg:pl-8px md:max-lg:pr-12px"
					>
						<div>
							<img
								class="self-start rtl:ml-12px ltr:mr-12px"
								[src]="
									branch?.targetAudience.includes(0) &&
									branch?.targetAudience.includes(1)
										? './assets/images/male-female-sign.svg'
										: branch?.targetAudience.includes(0)
										? './assets/images/female-sign.svg'
										: branch?.targetAudience.includes(1)
										? './assets/images/male-sign.svg'
										: ''
								"
								alt=""
								[ngClass]="
									selectedBranch?.id == branch?.id ? 'gradient-border' : ''
								"
							/>
							<!-- branch?.targetAudience?.includes(0) -->
						</div>
						<div class="w-[90%]">
							<div
								class="flex justify-between mb-[6px]"
								[ngClass]="
									selectedBranch?.id == branch?.id
										? ' text-off-white'
										: 'text-dark-grey'
								"
								*ngFor="let branch of organization?.branches; let indx = index"
							>
								<h1
									class="ltr:font-DIN-Bold font-bold rtl:font-medium text-font-16 leading-[20px] m-0 max-mobile:text-font-mobile-small"
								>
									<img
										(mouseover)="
											inCompleteDataHover = true; hoverId = branch?.id
										"
										(mouseout)="inCompleteDataHover = false; hoverId = null"
										*ngIf="!branch.isInformationCompleted"
										class="inline-block"
										src="assets/images/new-danger.svg"
										alt=""
									/>
									<div
										*ngIf="inCompleteDataHover && hoverId == branch?.id"
										class="absolute bg-main-color-black px-[16px] py-12px text-off-white text-font-14 rounded-[4px] max-w-[344px] top-[45px] right-[-15px] z-10"
									>
										{{ 'ORGANIZATION.SP_PROFILE.INFO_MISSING' | translate }}
									</div>
									{{ branch?.name | slice : 0 : 15 }}
									{{
										branch?.name?.length && branch.name.length > 15 ? '...' : ''
									}}

									<img
										*ngIf="branch?.isMain"
										class="inline-block"
										[src]="
											selectedBranch?.id == branch?.id
												? './assets/images/home-white.svg'
												: './assets/images/white.svg'
										"
										alt=""
									/>
								</h1>
								<mat-slide-toggle
									[disabled]="
										organization.status == 4 || !branch.isInformationCompleted
									"
									(click)="
										updateStatus(branch?.id, indx, $event, branch?.isActive)
									"
									[checked]="branch.isActive"
								></mat-slide-toggle>
							</div>
							<div
								class="inline-block py-[2px] px-[6px] rounded-[50px] mb-[6px]"
								[ngClass]="branch?.isActive ? 'bg-[#E2F5EE]' : 'bg-[#F2B8B5]'"
							>
								<div
									class="rounded-full w-[5px] h-[5px] inline-block m-[2px]"
									[ngClass]="branch?.isActive ? 'bg-[#00BA88]' : 'bg-[#B3261E]'"
								></div>
								<p
									class="inline-block m-0 max-mobile:text-font-mobile-small"
									[ngClass]="
										branch?.isActive ? 'text-[#00BA88]' : 'text-[#B3261E]'
									"
								>
									{{
										branch?.isActive
											? ('ACTIONS.ACTIVE' | translate)
											: ('ACTIONS.INACTIVE' | translate)
									}}
								</p>
							</div>
							<div class="flex mb-[6px]">
								<svg width="17" height="18" viewBox="0 0 17 18" fill="">
									<path
										d="M16.875 7.0875H10.4344L8.4375 0.84375L6.44062 7.0875H0L5.20312 10.9406L3.23438 17.1562L8.4375 13.3031L13.6406 17.1562L11.6438 10.9125L16.875 7.0875Z"
										fill="#FFCE31"
									/>
								</svg>
								<span class="text-font-medium text-[14px]">{{
									branch?.overAllRate
								}}</span
								><span class="text-[12px]"
									>({{ branch?.rateCount }}
									{{ 'ORGANIZATION.SP_PROFILE.RATINGS' | translate }})</span
								>
							</div>
							<p *ngIf="branch.address" class="text-font-14 leading-[22px] m-0">
								{{ branch?.address | slice : 0 : 40 }}
								{{
									branch?.address?.length && branch.address.length > 40
										? '...'
										: ''
								}}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="w-[98%] h-[1px] bg-secondry-color-Gray m-auto my-24px"></div>
			<!-- ----------SECTION TWO--------- -->
			<section>
				<p
					class="text-font-16 text-main-color-black ltr:font-DIN-Bold font-bold rtl:font-medium leading[20px] mb-12px"
				>
					{{ 'ORGANIZATION.SP_PROFILE.CHOOSE_CONTENT' | translate }}
				</p>
				<div
					class="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 gap-3 mb-24px"
				>
					<div
						[routerLink]="'../branch-information/' + selectedBranch?.id + '/2'"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] max-mobile:p-padding-mobile-14 max-mobile:m-0 max-mobile:w-full hover:bg-gradient hover:cursor-pointer group"
					>
						<div class="mb-12px flex justify-between">
							<svg
								viewBox="0 0 21.5 21.48"
								class="group-hover:fill-off-white fill-[#4E4B66] w-6"
							>
								<path
									d="M10.76,21.48A2.66,2.66,0,0,1,9,20.85L7.44,19.5a1.5,1.5,0,0,0-.77-.28H4.92a2.69,2.69,0,0,1-2.68-2.68V14.83A1.45,1.45,0,0,0,2,14.07L.62,12.47A2.73,2.73,0,0,1,.62,9L2,7.4a1.45,1.45,0,0,0,.27-.76V4.94A2.69,2.69,0,0,1,4.92,2.26H6.65A1.62,1.62,0,0,0,7.43,2L9,.62a2.76,2.76,0,0,1,3.49,0L14.07,2a1.57,1.57,0,0,0,.78.28h1.7a2.68,2.68,0,0,1,2.68,2.68v1.7a1.58,1.58,0,0,0,.29.77L20.87,9a2.74,2.74,0,0,1,0,3.49l-1.35,1.58a1.57,1.57,0,0,0-.28.77v1.7a2.68,2.68,0,0,1-2.68,2.68h-1.7a1.66,1.66,0,0,0-.78.29L12.5,20.84A2.64,2.64,0,0,1,10.76,21.48ZM4.92,3.76A1.19,1.19,0,0,0,3.74,4.94v1.7a2.89,2.89,0,0,1-.63,1.73L1.75,10a1.27,1.27,0,0,0,0,1.53l1.36,1.59a3,3,0,0,1,.63,1.73v1.71a1.17,1.17,0,0,0,1.17,1.18H6.65a3,3,0,0,1,1.74.64L10,19.71a1.26,1.26,0,0,0,1.54,0l1.58-1.35a3,3,0,0,1,1.74-.64h1.7a1.18,1.18,0,0,0,1.18-1.18v-1.7a3,3,0,0,1,.64-1.74l1.36-1.59a1.26,1.26,0,0,0,0-1.54L18.37,8.39a3,3,0,0,1-.64-1.74V4.94a1.18,1.18,0,0,0-1.18-1.18h-1.7a3,3,0,0,1-1.75-.64L11.51,1.76a1.26,1.26,0,0,0-1.54,0L8.4,3.12a3,3,0,0,1-1.75.64Zm5.83,11.85a1,1,0,1,1,1-1A1,1,0,0,1,10.75,15.61Zm0-3.15a.76.76,0,0,1-.75-.75V6.87a.75.75,0,0,1,1.5,0V11.7A.75.75,0,0,1,10.75,12.46Z"
								/>
							</svg>
							<div>
								<img
									*ngIf="!selectedBranch?.basicInfoComleted"
									class="inline-block w-6"
									src="assets/images/new-danger.svg"
									alt=""
								/>
							</div>
						</div>

						<p
							class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[18px] group-hover:text-off-white text-start whitespace-nowrap"
						>
							{{ 'ORGANIZATION.SP_PROFILE.BASIC_INFO' | translate }}
						</p>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] px-[10px] border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_BRANCH' | translate }}
							</p>
						</button>
					</div>

					<div
						[routerLink]="'../branch-information/' + selectedBranch?.id + '/2'"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] max-mobile:p-padding-mobile-14 max-mobile:m-0 max-mobile:w-full hover:bg-gradient hover:cursor-pointer group"
					>
						<div class="mb-12px flex justify-between">
							<svg
								width="25"
								height="24"
								viewBox="0 0 25 24"
								class="group-hover:fill-off-white fill-[#4E4B66] w-6"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12.5013 13.3008C12.3713 13.3008 12.2413 13.2709 12.1213 13.2009L3.29132 8.09088C2.93132 7.88088 2.8113 7.42085 3.0213 7.06085C3.2313 6.70085 3.6813 6.58083 4.0513 6.79083L12.5013 11.6808L20.9013 6.82086C21.2613 6.61086 21.7213 6.74088 21.9313 7.09088C22.1413 7.45088 22.0113 7.91085 21.6613 8.12085L12.8913 13.2009C12.7613 13.2609 12.6313 13.3008 12.5013 13.3008Z"
								/>
								<path
									d="M12.5 22.3591C12.09 22.3591 11.75 22.0191 11.75 21.6091V12.5391C11.75 12.1291 12.09 11.7891 12.5 11.7891C12.91 11.7891 13.25 12.1291 13.25 12.5391V21.6091C13.25 22.0191 12.91 22.3591 12.5 22.3591Z"
								/>
								<path
									d="M12.5006 22.75C11.6206 22.75 10.7506 22.56 10.0606 22.18L4.72061 19.21C3.27061 18.41 2.14062 16.48 2.14062 14.82V9.16998C2.14062 7.50998 3.27061 5.59002 4.72061 4.78002L10.0606 1.82C11.4306 1.06 13.5706 1.06 14.9406 1.82L20.2806 4.78997C21.7306 5.58997 22.8606 7.51999 22.8606 9.17999V14.83C22.8606 16.49 21.7306 18.41 20.2806 19.22L14.9406 22.18C14.2506 22.56 13.3806 22.75 12.5006 22.75ZM12.5006 2.74999C11.8706 2.74999 11.2506 2.88 10.7906 3.13L5.45062 6.09997C4.49062 6.63997 3.64062 8.06999 3.64062 9.17999V14.83C3.64062 15.93 4.49062 17.37 5.45062 17.91L10.7906 20.88C11.7006 21.39 13.3006 21.39 14.2106 20.88L19.5506 17.91C20.5106 17.37 21.3606 15.94 21.3606 14.83V9.17999C21.3606 8.07999 20.5106 6.63997 19.5506 6.09997L14.2106 3.13C13.7506 2.88 13.1306 2.74999 12.5006 2.74999Z"
								/>
								<path
									d="M17.5012 13.9905C17.0912 13.9905 16.7512 13.6505 16.7512 13.2405V10.0206L7.63116 4.76055C7.27116 4.55055 7.15114 4.09054 7.36114 3.74054C7.57114 3.38054 8.02116 3.26052 8.38116 3.47052L17.8712 8.95056C18.1012 9.08056 18.2512 9.33052 18.2512 9.60052V13.2606C18.2512 13.6506 17.9112 13.9905 17.5012 13.9905Z"
								/>
							</svg>
						</div>
						<div class="flex justify-between">
							<p
								class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[18px] group-hover:text-off-white text-start whitespace-nowrap"
							>
								{{ 'ORGANIZATION.SP_PROFILE.PRODUCTS' | translate }}
							</p>
							<p class="text-dark-grey text-font-14">
								30 {{ 'ORGANIZATION.SP_PROFILE.PRODUCTS' | translate }}
							</p>
						</div>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] px-[10px] border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_PRODUCTS' | translate }}
							</p>
						</button>
					</div>

					<div
						[routerLink]="'../branch-information/' + selectedBranch?.id + '/2'"
						class="border-[1px] border-secondry-color-Gray bg-off-white rounded-12px py-24px px-[20px] max-mobile:p-padding-mobile-14 max-mobile:m-0 max-mobile:w-full hover:bg-gradient hover:cursor-pointer group"
					>
						<div class="mb-12px flex justify-between">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								class="group-hover:fill-off-white fill-[#4E4B66] w-6"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M16.5 8.6303C16.09 8.6303 15.75 8.2903 15.75 7.8803V6.5003C15.75 5.4503 15.3 4.4303 14.52 3.7203C13.73 3.0003 12.71 2.6703 11.63 2.7703C9.83 2.9403 8.25 4.7803 8.25 6.7003V7.6703C8.25 8.0803 7.91 8.4203 7.5 8.4203C7.09 8.4203 6.75 8.0803 6.75 7.6703V6.6903C6.75 4.0003 8.92 1.5203 11.49 1.2703C12.99 1.1303 14.43 1.6003 15.53 2.6103C16.62 3.6003 17.25 5.0203 17.25 6.5003V7.8803C17.25 8.2903 16.91 8.6303 16.5 8.6303Z"
								/>
								<path
									d="M14.9998 22.75H8.99982C4.37982 22.75 3.51982 20.6 3.29982 18.51L2.54982 12.52C2.43982 11.44 2.39982 9.89 3.44982 8.73C4.34982 7.73 5.83982 7.25 7.99982 7.25H15.9998C18.1698 7.25 19.6598 7.74 20.5498 8.73C21.5898 9.89 21.5598 11.44 21.4498 12.5L20.6998 18.51C20.4798 20.6 19.6198 22.75 14.9998 22.75ZM7.99982 8.75C6.30982 8.75 5.14982 9.08 4.55982 9.74C4.06982 10.28 3.90982 11.11 4.03982 12.35L4.78982 18.34C4.95982 19.94 5.39982 21.26 8.99982 21.26H14.9998C18.5998 21.26 19.0398 19.95 19.2098 18.36L19.9598 12.35C20.0898 11.13 19.9298 10.3 19.4398 9.75C18.8498 9.08 17.6898 8.75 15.9998 8.75H7.99982Z"
								/>
								<path
									d="M15.4202 13.1484C14.8602 13.1484 14.4102 12.6984 14.4102 12.1484C14.4102 11.5984 14.8602 11.1484 15.4102 11.1484C15.9602 11.1484 16.4102 11.5984 16.4102 12.1484C16.4102 12.6984 15.9702 13.1484 15.4202 13.1484Z"
								/>
								<path
									d="M8.42016 13.1484C7.86016 13.1484 7.41016 12.6984 7.41016 12.1484C7.41016 11.5984 7.86016 11.1484 8.41016 11.1484C8.96016 11.1484 9.41016 11.5984 9.41016 12.1484C9.41016 12.6984 8.97016 13.1484 8.42016 13.1484Z"
								/>
							</svg>

							<svg
								width="9"
								height="8"
								viewBox="0 0 9 8"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								class="mt-3"
							>
								<circle cx="4.5" cy="4" r="4" fill="#F2536F" />
							</svg>
						</div>
						<div class="flex justify-between">
							<p
								class="ltr:font-DIN-Bold font-bold rtl:font-medium text-dark-grey text-font-18 max-mobile:text-[14px] rounded leading-22px mb-[18px] group-hover:text-off-white text-start whitespace-nowrap"
							>
								{{ 'ORGANIZATION.SP_PROFILE.ORDERS' | translate }}
							</p>
							<p class="text-dark-grey text-font-14">
								30 {{ 'ORGANIZATION.SP_PROFILE.ORDERS' | translate }}
							</p>
						</div>
						<button
							class="text-font-14 leading-22px text-dark-grey py-[10px] max-mobile:py-[5px] px-[10px] border-[1px] border-secondry-color-Gray rounded-6px group-hover:text-salon group-hover:bg-off-white group w-full"
						>
							<p
								class="whitespace-nowrap max-mobile:whitespace-normal text-[14px] m-0 max-mobile:text-font-mobile-small"
							>
								{{ 'ORGANIZATION.SP_PROFILE.VIEW_ORDERS' | translate }}
							</p>
						</button>
					</div>
				</div>
			</section>
		</div>
	</div>
</div>
